import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import { transformDate } from "services/Local-services";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHFeriadoSerieDel } from "services/services-mia/programa-salud/feriados/RNHFeriadoSerieDel";

/**
 * Baja de UNA fecha.
 *
 * A diferencia del resto de las bajas del modulo, que muestran solo el nombre, acá van
 * los dos campos: el feriado solo no alcanza para saber cuál de sus fechas se está por
 * borrar, que es justamente lo que hay que confirmar.
 *
 * El feriado en sí no se toca: sigue existiendo con el resto de sus fechas.
 */
export default function DeleteModal({ row, updateList, closeModal, setterRowSelected }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const [inRequest, setInRequest] = useState(false);
  const formikRef = useRef();

  const eliminarFecha = async () => {
    setInRequest(true);
    const respuesta = await RNHFeriadoSerieDel(credentials, {
      feriadoSerieId: row?.id,
      version: row?.version,
    });
    setInRequest(false);

    if (!respuesta.ok) return;

    setSnackBarInfo({
      message: "Fecha eliminada correctamente",
      severity: "success",
      open: true,
    });
    formikRef.current.resetForm();
    updateList();
    setterRowSelected({ status: false, row: {} });
    closeModal();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        feriado: row?.feriado ?? "",
        // La fila guarda la fecha cruda (2026-05-01) porque es lo que ordena la grilla;
        // acá se muestra como en toda la app.
        fecha: row?.fecha ? transformDate(row.fecha) : "",
      }}
      onSubmit={() => {
        eliminarFecha();
      }}
    >
      <Form className={styles.inputs} noValidate>
        <div className={styles["column"]}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={2}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
            }}
          >
            <Grid item xs={8}>
              <FormikTextInput
                fullWidth={true}
                name="feriado"
                labelText="Feriado"
                readOnly
              />
            </Grid>
            <Grid item xs={4}>
              <FormikTextInput
                fullWidth={true}
                name="fecha"
                labelText="Fecha"
                readOnly
              />
            </Grid>
          </Grid>
          <FormButton
            inRequest={inRequest}
            newFormData={{ button: "Eliminar" }}
            onCloseModal={closeModal}
          />
          {inRequest && <SpinnerOverlay />}
        </div>
      </Form>
    </Formik>
  );
}
